import { HorseArt } from "@/components/game/HorseArt";
import { Star } from "lucide-react";

const DIFF_TONE = {
  1: "bg-green-100 text-green-700", 2: "bg-blue-100 text-blue-700",
  3: "bg-amber-100 text-amber-700", 4: "bg-red-100 text-red-700",
};

export const HorseCard = ({ horse, onSelect, busy }) => (
  <div data-testid={`horse-card-${horse.tag}`}
    className="overflow-hidden rounded-2xl border border-border bg-card shadow-sm">
    <div className="flex items-center justify-center py-3" style={{ background: `${horse.color_hex}1a` }}>
      <HorseArt src={horse.art_image} color={horse.color_hex} size={110} />
    </div>
    <div className="p-4">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-xl font-bold text-primary">Tag #{horse.tag}</h3>
        <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${DIFF_TONE[horse.difficulty]}`}>
          {horse.difficulty_label}
        </span>
      </div>
      <p className="text-xs font-semibold text-secondary">{horse.hma} HMA</p>
      <p className="mt-1 text-sm text-muted-foreground">
        {horse.color} · {horse.sex} · {horse.age} yrs · {horse.height}
      </p>
      <p className="text-xs text-muted-foreground">{horse.markings}</p>
      <span className="mt-2 inline-block rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-bold text-primary">
        {horse.division}
      </span>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {horse.personality.map((t) => (
          <span key={t} className="rounded-full bg-muted px-2 py-0.5 text-[11px] font-semibold text-foreground/70">{t}</span>
        ))}
      </div>
      <p className="mt-2 flex items-center gap-1 text-[11px] text-muted-foreground">
        <Star size={11} className="text-secondary" /> Natural strengths hidden until you train — every horse has quirks!
      </p>
      <button data-testid={`choose-horse-${horse.tag}`} disabled={busy} onClick={() => onSelect(horse)}
        className="mt-3 h-11 w-full rounded-xl bg-secondary font-bold text-white disabled:opacity-60 active:scale-95">
        Choose Tag #{horse.tag}
      </button>
    </div>
  </div>
);
